import { paymentActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  updated: false,
  currentPayment: null,
  error: null,
  message: null,
  pdf: null,
  lastCreated: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case paymentActions.PAYMENT_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        updated: false,
        currentPayment: state.currentPayment || null,
        error: null,
        pdf: state.pdf || null,
        lastCreated: null
      };
    case paymentActions.PAYMENT_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false,
        currentPayment: state.currentPayment || null,
        error: action.error,
        pdf: state.pdf || null,
        lastCreated: null
      };
    case paymentActions.PAYMENT:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        updated: false,
        currentPayment: state.currentPayment || null,
        error: null,
        pdf: state.pdf || null,
        lastCreated: action.lastCreated
      };
    case paymentActions.PAYMENT_PDF:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false,
        currentPayment: state.currentPayment || null,
        error: null,
        pdf: action.pdf || null,
        lastCreated: null
      };
    case paymentActions.SELECT_PAYMENT_RESET:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false,
        currentPayment: null,
        error: null,
        pdf: null,
        lastCreated: null
      };
    case paymentActions.PAYMENT_UPDATED:
      return {
        ...state,
        isLoading: false,
        data: action.data || [],
        updated: true,
        currentPayment: state.currentPayment || null,
        error: null,
        pdf: null,
        lastCreated: null
      };
    case paymentActions.MASSIVE_PAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data || [],
        updated: true,
        currentPayment: state.currentPayment || null,
        error: null,
        pdf: null,
        lastCreated: null
      };
    case paymentActions.MASSIVE_PAYMENT_ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data || [],
        updated: true,
        currentPayment: state.currentPayment || null,
        error: action.error,
        pdf: null,
        lastCreated: null
      };
    default:
      return state;
  }
};
